import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, Modal } from '../../components/shared';
import api from '../../services/api';
import toast from 'react-hot-toast';

const FORM_VAZIO = { nome: '', email: '', senha: '', perfil: 'master', empresa_id: '', status: 'ativo' };
const FORM_SENHA = { senha: '', confirmar: '' };

export default function MasterUsuarios() {
  const [usuarios, setUsuarios]   = useState([]);
  const [empresas, setEmpresas]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [busca, setBusca]         = useState('');

  const [modal, setModal]         = useState(false);
  const [editando, setEditando]   = useState(null);
  const [form, setForm]           = useState(FORM_VAZIO);
  const [salvando, setSalvando]   = useState(false);

  const [modalSenha, setModalSenha]   = useState(false);
  const [alvoSenha, setAlvoSenha]     = useState(null);
  const [formSenha, setFormSenha]     = useState(FORM_SENHA);
  const [salvandoSenha, setSalvandoSenha] = useState(false);

  const carregar = () => {
    setLoading(true);
    api.get('/usuarios')
      .then(r => setUsuarios(r.data))
      .catch(() => toast.error('Erro ao carregar usuários'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    carregar();
    api.get('/empresas?limit=200')
      .then(r => setEmpresas(r.data.dados || []))
      .catch(() => {});
  }, []);

  // ── Modal novo / editar ─────────────────────────────────────
  const abrirNovo = () => {
    setEditando(null);
    setForm(FORM_VAZIO);
    setModal(true);
  };

  const abrirEditar = (u) => {
    setEditando(u);
    setForm({ nome: u.nome, email: u.email, senha: '', perfil: u.perfil, empresa_id: u.empresa_id || '', status: u.status });
    setModal(true);
  };

  const fechar = () => { setModal(false); setEditando(null); setForm(FORM_VAZIO); };

  const campo = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const salvar = async (e) => {
    e.preventDefault();
    if (form.perfil === 'admin_empresa' && !form.empresa_id)
      return toast.error('Selecione uma empresa');
    setSalvando(true);
    try {
      if (editando) {
        const payload = { nome: form.nome, email: form.email, status: form.status };
        if (form.senha) payload.senha = form.senha;
        await api.put(`/usuarios/${editando.id}`, payload);
        toast.success('Usuário atualizado!');
      } else {
        const payload = { nome: form.nome, email: form.email, senha: form.senha, perfil: form.perfil };
        if (form.perfil === 'admin_empresa') payload.empresa_id = form.empresa_id;
        await api.post('/usuarios', payload);
        toast.success('Usuário criado com sucesso!');
      }
      fechar();
      carregar();
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  // ── Toggle status rápido ────────────────────────────────────
  const toggleStatus = async (u) => {
    const novoStatus = u.status === 'ativo' ? 'inativo' : 'ativo';
    try {
      await api.put(`/usuarios/${u.id}`, { status: novoStatus });
      toast.success(`Usuário ${novoStatus === 'ativo' ? 'ativado' : 'inativado'}!`);
      carregar();
    } catch {
      toast.error('Erro ao alterar status');
    }
  };

  // ── Modal redefinir senha ───────────────────────────────────
  const abrirSenha = (u) => { setAlvoSenha(u); setFormSenha(FORM_SENHA); setModalSenha(true); };
  const fecharSenha = () => { setModalSenha(false); setAlvoSenha(null); setFormSenha(FORM_SENHA); };

  const salvarSenha = async (e) => {
    e.preventDefault();
    if (formSenha.senha !== formSenha.confirmar)
      return toast.error('As senhas não coincidem');
    if (formSenha.senha.length < 6)
      return toast.error('A senha deve ter pelo menos 6 caracteres');
    setSalvandoSenha(true);
    try {
      await api.put(`/usuarios/${alvoSenha.id}`, { senha: formSenha.senha });
      toast.success('Senha redefinida com sucesso!');
      fecharSenha();
    } catch {
      toast.error('Erro ao redefinir senha');
    } finally {
      setSalvandoSenha(false);
    }
  };

  // ── Filtro ─────────────────────────────────────────────────
  const usuariosFiltrados = usuarios.filter(u => {
    const q = busca.toLowerCase();
    return u.nome.toLowerCase().includes(q) || u.email.toLowerCase().includes(q);
  });

  const tituloModal = editando
    ? `Editar — ${editando.nome}`
    : form.perfil === 'master' ? 'Novo Usuário Master' : 'Novo Admin de Empresa';

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="master" />
      <div className="main-content">
        <div className="topbar">
          <h1>Usuários da Plataforma</h1>
          <button className="btn btn-primary" onClick={abrirNovo}>
            <Icon name="plus" size={16} /> Novo Usuário
          </button>
        </div>

        <div className="page-content">
          <div style={{ marginBottom: '16px', position: 'relative', maxWidth: '360px' }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)', display: 'flex' }}>
              <Icon name="search" size={16} />
            </span>
            <input
              className="form-control"
              placeholder="Buscar por nome ou e-mail..."
              value={busca}
              onChange={e => setBusca(e.target.value)}
              style={{ paddingLeft: '34px' }}
            />
          </div>

          {loading ? <div className="loading-center"><div className="spinner" /></div> : (
            <div className="table-card">
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>E-mail</th>
                      <th>Perfil</th>
                      <th>Empresa</th>
                      <th>Status</th>
                      <th style={{ textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuariosFiltrados.map(u => (
                      <tr key={u.id}>
                        <td style={{ fontWeight: 600 }}>{u.nome}</td>
                        <td style={{ color: 'var(--text-muted)' }}>{u.email}</td>
                        <td>
                          <span className={`badge ${u.perfil === 'master' ? 'badge-orange' : 'badge-info'}`}>
                            {u.perfil === 'master' ? 'Master' : 'Admin Empresa'}
                          </span>
                        </td>
                        <td>{u.empresa || '—'}</td>
                        <td>
                          <span className={`badge ${u.status === 'ativo' ? 'badge-success' : 'badge-danger'}`}>
                            {u.status}
                          </span>
                        </td>
                        <td>
                          <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                            <button
                              className="btn btn-sm"
                              onClick={() => abrirEditar(u)}
                              title="Editar"
                              style={{ padding: '4px 8px' }}
                            >
                              <Icon name="edit" size={14} />
                            </button>
                            <button
                              className="btn btn-sm"
                              onClick={() => abrirSenha(u)}
                              title="Redefinir senha"
                              style={{ padding: '4px 8px' }}
                            >
                              <Icon name="eye" size={14} />
                            </button>
                            <button
                              className={`btn btn-sm ${u.status === 'ativo' ? 'btn-danger' : 'btn-success'}`}
                              onClick={() => toggleStatus(u)}
                              title={u.status === 'ativo' ? 'Inativar' : 'Ativar'}
                              style={{ padding: '4px 8px', fontSize: '.75rem' }}
                            >
                              {u.status === 'ativo' ? 'Inativar' : 'Ativar'}
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {!usuariosFiltrados.length && (
                      <tr><td colSpan={6}>
                        <div className="empty-state">
                          <Icon name="users" />
                          <h3>{busca ? 'Nenhum usuário encontrado para essa busca' : 'Nenhum usuário encontrado'}</h3>
                        </div>
                      </td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Modal criar / editar ── */}
      <Modal open={modal} onClose={fechar} title={tituloModal}>
        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '20px' }}>

          {!editando && (
            <div className="form-group">
              <label className="form-label">Tipo de usuário *</label>
              <select
                className="form-control"
                value={form.perfil}
                onChange={e => campo('perfil', e.target.value)}
              >
                <option value="master">Master</option>
                <option value="admin_empresa">Admin de Empresa</option>
              </select>
            </div>
          )}

          {!editando && form.perfil === 'admin_empresa' && (
            <div className="form-group">
              <label className="form-label">Empresa *</label>
              <select
                className="form-control"
                value={form.empresa_id}
                onChange={e => campo('empresa_id', e.target.value)}
                required
              >
                <option value="">Selecione uma empresa...</option>
                {empresas.map(e => (
                  <option key={e.id} value={e.id}>{e.nome_fantasia}</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Nome *</label>
            <input
              className="form-control"
              value={form.nome}
              onChange={e => campo('nome', e.target.value)}
              placeholder="Nome completo"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">E-mail *</label>
            <input
              className="form-control"
              type="email"
              value={form.email}
              onChange={e => campo('email', e.target.value)}
              placeholder="email@exemplo.com"
              required
            />
          </div>

          {!editando && (
            <div className="form-group">
              <label className="form-label">Senha *</label>
              <input
                className="form-control"
                type="password"
                value={form.senha}
                onChange={e => campo('senha', e.target.value)}
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
              />
            </div>
          )}

          {editando && (
            <div className="form-group">
              <label className="form-label">Status</label>
              <select
                className="form-control"
                value={form.status}
                onChange={e => campo('status', e.target.value)}
              >
                <option value="ativo">Ativo</option>
                <option value="inativo">Inativo</option>
              </select>
            </div>
          )}

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '4px' }}>
            <button type="button" className="btn" onClick={fechar}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={salvando}>
              {salvando ? 'Salvando...' : editando ? 'Salvar Alterações' : 'Criar Usuário'}
            </button>
          </div>
        </form>
      </Modal>

      {/* ── Modal redefinir senha ── */}
      <Modal open={modalSenha} onClose={fecharSenha} title={`Redefinir Senha — ${alvoSenha?.nome}`}>
        <form onSubmit={salvarSenha} style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '20px' }}>
          <div className="form-group">
            <label className="form-label">Nova senha *</label>
            <input
              className="form-control"
              type="password"
              value={formSenha.senha}
              onChange={e => setFormSenha(f => ({ ...f, senha: e.target.value }))}
              placeholder="Mínimo 6 caracteres"
              required
              minLength={6}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Confirmar nova senha *</label>
            <input
              className="form-control"
              type="password"
              value={formSenha.confirmar}
              onChange={e => setFormSenha(f => ({ ...f, confirmar: e.target.value }))}
              placeholder="Repita a senha"
              required
            />
          </div>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button type="button" className="btn" onClick={fecharSenha}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={salvandoSenha}>
              {salvandoSenha ? 'Salvando...' : 'Redefinir Senha'}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
